import { Link } from 'react-router-dom';
import { FacilityStatusEnum } from '../../../api';
import { PresentationBadge } from '../PresentationBadge';

export interface FacilityCellProps {
  facility: {
    id: string;
    name: string;
  };
  status: string;
  showStatus: boolean;
}

export const FacilityCell = ({ facility, status, showStatus }: FacilityCellProps) => {
  return (
    <>
      <Link
        className="d-inline-block align-middle me-2 text-truncate"
        to={`/app/organization/facilities/${facility.id}`}
        key={facility.id}
      >
        {facility.name}
      </Link>
      {showStatus && status && (
        <div>
          <span className="fs-12 me-2">Present. Status:</span>
          <PresentationBadge className="p-0" isTransparent status={status as FacilityStatusEnum} />
        </div>
      )}
    </>
  );
};
